import { useMemo } from 'react'

import {
  formatMaxFileSizeExceededMessage,
} from 'Pods/ThreeDStudio/Shared/Utils/formatMaxFileSizeExceededMessage'
import { getInputFileUploadConstraints } from 'Pods/ThreeDStudio/Shared/Utils/getInputFileUploadConstraints'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

export default function useEnhancedModelCompatibility() {
  const fileFormat = useThreeDStudioStore(state => state.viewer.fileFormat)
  const fileSize = useThreeDStudioStore(state => state.viewer.fileSize)
  const modelSchema = useThreeDStudioStore(state => state.schema.enhancedModelSchema)

  const { allowedTypes, maxFileSize } = useMemo(
    () => getInputFileUploadConstraints(modelSchema, 'input_3d'),
    [modelSchema],
  )

  const isFormatUnsupported = !allowedTypes.includes(fileFormat)
  const isFileSizeExceeded = fileSize != null && fileSize > maxFileSize
  const isModelIncompatible = isFormatUnsupported || isFileSizeExceeded

  const tooltipMessage = useMemo(() => {
    if (isFormatUnsupported) {
      const allowedList = allowedTypes.map(type => type.toUpperCase()).join(', ')
      const currentFormat = fileFormat?.toUpperCase()
      const prefix = currentFormat
        ? `File format ${currentFormat} is not supported.`
        : 'File format not supported.'

      return `${prefix} Please upload one of the following formats: ${allowedList}.`
    }

    if (isFileSizeExceeded) {
      return formatMaxFileSizeExceededMessage(maxFileSize)
    }

    return undefined
  }, [allowedTypes, fileFormat, isFormatUnsupported, isFileSizeExceeded, maxFileSize])

  return { isModelIncompatible, tooltipMessage }
}
